import React, { useEffect, useState } from "react";
import Use_Reference_Material_table from "./use_Reference_Material_table/Use_Reference_Material_table";
import Use_Reference_Material_Form from "./use_Reference_Material_Form/Use_Reference_Material_Form";
import {
  Create,
  GetAll,
} from "../../../../../../../../src/features/admin/quality_management/process_requirement/validity/Slice";
import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../../../utils/fixIDS";

function Use_Reference_Material({
  validitydetails,
  setCurrentPage,
  currentPage,
  openDeleteModal
}) {
  
  const [showTable, setShowTable] = useState(false);

  const permissions = useSelector((state) => state.auth.permissions);
                                          
  const haveReadPermission = permissions?.includes(FixIDS.ensuring_the_validity.List);
  const haveAddPermission = permissions?.includes(FixIDS.use_of_reference_material.Add); //form

  return (
    <>
      <div className="imperiality_Form_div">
        { haveAddPermission && <Use_Reference_Material_Form
          validityTypeId={1}
          onProceed={() => setShowTable(true)}
        />}
      </div>

      {/* {showTable && ( */}
      <div className="imperiality_table_div">
        { haveReadPermission && <Use_Reference_Material_table
         openDeleteModal={openDeleteModal}
          validitydetails={validitydetails}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          validityTypeId={1}
        />}
      </div>
      {/* )} */}
    </>
  );
}

export default Use_Reference_Material;
